module.exports = __webpack_public_path__ + "static/media/13import-30.dc6ee9ba.xlsx";